import React from "react";
import classNames from "classnames";
import smileIcon from "static-file/images/bg_address_none.png";
import warningICon from "static-file/images/bg_delivery_none.png";

/**
 * @description 정보 패널 컴포넌트
 * @param variant 아이콘 종류
 * @param title 제목
 * @param subtitle 서브 텍스트
 * @param children 추가적인 컨텐츠
 * @param className 추가적인 클래스명
 */

interface InfoPanelProps {
  variant?: "smile" | "warning";
  title: string;
  subtitle?: string;
  children?: React.ReactNode;
  className?: string;
}

const InfoPanel: React.FC<InfoPanelProps> = ({ variant, title, subtitle, children, className }) => {
  const icon = {
    smile: <img src={smileIcon} alt="출력" />,
    warning: <img src={warningICon} alt="출력" />,
  };
  return (
    <div className={classNames("flex flex-col items-center justify-center space-y-4 py-4", className)}>
      <div className="flex items-center gap-3">
        {icon[variant as keyof typeof icon]}
        <span className="text-[22px] font-bold">{title}</span>
      </div>
      <p className="text-text-tertiary text-base">{subtitle ?? ""}</p>
      {children && <div className="pt-2">{children}</div>}
    </div>
  );
};

export default InfoPanel;
